











import { Component, Model } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Input from './input'
import * as ruleNames from './constants/ruleNames'

@Component
export default class NumberInput extends mixins(Input) {
  @Model('input', { type: Number }) value!: number

  castFunction = (value: string | null) => {
    if (value === '') {
      return null
    }

    return Number(value)
  }

  supportedRules: Array<string> = [
    ruleNames.REQUIRED,
    ruleNames.MIN_VALUE,
    ruleNames.MAX_VALUE,
    ruleNames.BETWEEN
  ]

  get min() {
    if (this.rules[ruleNames.MIN_VALUE] !== undefined) {
      return this.rules[ruleNames.MIN_VALUE] as number
    }

    if (this.rules[ruleNames.BETWEEN]) {
      return this.rules[ruleNames.BETWEEN][0] as number
    }

    return null
  }

  get max() {
    if (this.rules[ruleNames.MAX_VALUE] !== undefined) {
      return this.rules[ruleNames.MAX_VALUE] as number
    }

    if (this.rules[ruleNames.BETWEEN]) {
      return this.rules[ruleNames.BETWEEN][1] as number
    }

    return null
  }
}
